type GenerateRequestViewingSubscriptionTrackingLabelParams = {
  /**
   * Boolean that defines whether the user has changed the default message.
   */
  messageChanged: boolean
  /**
   * The number of available dates selected by the user
   */
  datesSelected: number
  /**
   * The full name of the user. E.g John Doe.
   */
  fullName: string
  /**
   * Boolean that defines whether the user has saved their name for future requests
   */
  saveName: boolean
}

/**
 * Generates a tracking label for an attempt or a successful request a viewing in subscription seller mode. Returns the encoded tracking label string.
 *
 * @param params - The parameters for generating the tracking label.
 * @param params.messageChanged - Boolean that defines whether the user has changed the default message.
 * @param params.datesSelected - The number of available dates selected by the user
 * @param params.fullName - The full name of the user. E.g John Doe.
 * @param params.saveName - Boolean that defines whether the user has saved their name for future requests.
 * @returns The generated tracking label. E.g: seller_type=subscription;message=1;full_name=1;dates_selected=2;save_name=1
 */
export const generateRequestViewingSubscriptionTrackingLabel = ({
  messageChanged,
  datesSelected,
  fullName,
  saveName,
}: GenerateRequestViewingSubscriptionTrackingLabelParams) => {
  let trackingData = `seller_type=subscription;`

  trackingData += `message=${messageChanged ? '1' : '0'};`
  trackingData += `full_name=${fullName ? '1' : '0'};`
  trackingData += `dates_selected=${datesSelected};`
  trackingData += `save_name=${saveName ? '1' : '0'};`

  return trackingData
}
